import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import {
    Country,
    SORTED_COUNTRIES,
    findCountry,
    findCountryByPrefix,
} from '../../commons/countries';
import { PhoneValidation, PhoneValue } from '../../utils/phone-validation';

// Selector tara (steag + prefix) si numarul fara prefix. Se foloseste cu v-model (PhoneValue).
// Steagurile vin din flag-icon-css, importat global in components/layout.
@Component
export default class PhoneInput extends Vue {
    @Prop({ type: Object, required: true }) readonly value!: PhoneValue;
    @Prop({ type: String, default: '' }) readonly placeholder!: string;

    private open: boolean = false;
    private search: string = '';

    get selected(): Country | undefined {
        return (
            findCountry(this.value.phoneCountry) ||
            findCountryByPrefix(this.value.prefix)
        );
    }

    get filtered(): Country[] {
        const term = this.search.trim().toLowerCase();

        if (!term) {
            return SORTED_COUNTRIES;
        }

        const digits = term.replace(/\D/g, '');

        return SORTED_COUNTRIES.filter(
            (c) =>
                c.name.toLowerCase().indexOf(term) !== -1 ||
                c.nameEn.toLowerCase().indexOf(term) !== -1 ||
                c.iso2.toLowerCase() === term ||
                (digits !== '' && c.prefix.indexOf('+' + digits) === 0),
        );
    }

    flagClass(country?: Country): string {
        return country ? 'flag-icon flag-icon-' + country.iso2.toLowerCase() : '';
    }

    toggle() {
        this.open = !this.open;
        this.search = '';

        if (this.open) {
            this.$nextTick(() => {
                const search = this.$refs.search as HTMLInputElement;

                if (search) {
                    search.focus();
                }
            });
        }
    }

    select(country: Country) {
        this.open = false;
        this.$emit('input', {
            ...this.value,
            prefix: country.prefix,
            phoneCountry: country.iso2,
        });
    }

    // Enter in cautare alege prima tara, fara sa trimita formularul parinte
    selectFirst() {
        if (this.filtered.length) {
            this.select(this.filtered[0]);
        }
    }

    onPhoneInput(event: Event) {
        const raw = (event.target as HTMLInputElement).value;

        // Daca se lipeste numarul complet (+40..., 0040...), mutam prefixul in selector
        const detected = PhoneValidation.detectPrefix(raw);

        if (detected) {
            (event.target as HTMLInputElement).value = detected.phone;
            this.$emit('input', detected);
            return;
        }

        this.$emit('input', { ...this.value, phone: raw });
    }

    onDocumentClick(event: Event) {
        if (this.open && !this.$el.contains(event.target as Node)) {
            this.open = false;
        }
    }

    mounted() {
        document.addEventListener('click', this.onDocumentClick);
    }

    beforeDestroy() {
        document.removeEventListener('click', this.onDocumentClick);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/phone-input/index.ts